import type { Category, CategoryFilter, ViewMode } from "../../../shared/types";
import { HeaderBar } from "../../../ui/molecules/HeaderBar";
import { CategoryPills } from "../../../ui/molecules/CategoryPills";
import { EyeIcon, EyeOffIcon } from "../../../ui/icons";

interface AppHeaderProps {
  viewMode: ViewMode;
  activeFilter: CategoryFilter;
  hideHidden: boolean;
  isAdmin?: boolean;
  counts: Record<Category, number>;
  completionRates: Record<Category, number>;
  totalCount: number;
  pomodoroActive: boolean;
  pomodoroTimeLeft: number;
  hasTimers?: boolean;
  anyTimerRunning?: boolean;
  runningTimerCount?: number;
  onSearch: () => void;
  onSettings: () => void;
  onBugReport: () => void;
  onFilterChange: (filter: CategoryFilter) => void;
  onHideHiddenToggle: () => void;
  onTimerToggle?: () => void;
  sidebarPinned?: boolean;
  desktopBottomBar?: boolean;
}

export function AppHeader({
  viewMode,
  activeFilter,
  hideHidden,
  isAdmin,
  counts,
  completionRates,
  totalCount,
  pomodoroActive,
  pomodoroTimeLeft,
  hasTimers,
  anyTimerRunning,
  runningTimerCount,
  onSearch,
  onSettings,
  onBugReport,
  onFilterChange,
  onHideHiddenToggle,
  onTimerToggle,
  sidebarPinned,
  desktopBottomBar,
}: AppHeaderProps) {
  const showCategoryPills = ["today", "calendar", "tasks", "habits", "agenda", "kanban", "eisenhower"].includes(
    viewMode,
  );

  return (
    <>
      {/* Hide HeaderBar on desktop when bottom bar is active */}
      <div className={desktopBottomBar ? "md:hidden" : ""}>
        <HeaderBar
          onSearch={onSearch}
          onSettings={onSettings}
          onBugReport={onBugReport}
          sidebarPinned={sidebarPinned}
          pomodoroActive={pomodoroActive}
          pomodoroTimeLeft={pomodoroTimeLeft}
          hasTimers={hasTimers}
          anyTimerRunning={anyTimerRunning}
          runningTimerCount={runningTimerCount}
          onTimerToggle={onTimerToggle}
        />
      </div>

      {showCategoryPills && (
        <div className="border-b border-border/50 bg-surface px-4 py-2 flex items-center justify-between">
          <div className="flex-1 min-w-0 overflow-x-auto scrollbar-hide">
            <CategoryPills
              active={activeFilter}
              onChange={onFilterChange}
              counts={counts}
              totalCount={totalCount}
              completionRates={completionRates}
            />
          </div>
          {isAdmin && (
            <button
              type="button"
              onClick={onHideHiddenToggle}
              title={hideHidden ? "Afficher hidden" : "Masquer hidden"}
              className={`ml-2 shrink-0 w-6 h-6 flex items-center justify-center rounded text-[10px] font-medium transition-colors ${
                hideHidden
                  ? "bg-accent/10 text-accent"
                  : "text-ink-faint hover:text-ink hover:bg-surface-alt"
              }`}
            >
              {hideHidden ? <EyeOffIcon className="w-3.5 h-3.5" /> : <EyeIcon className="w-3.5 h-3.5" />}
            </button>
          )}
        </div>
      )}
    </>
  );
}
